import * as _ from 'lodash';
import { SEASONS as seasons } from './constants';

export const isObject = value => {
  return value && typeof value === 'object' && value.constructor === Object;
};

export const getTextFromReactNode = (node = { props: {} }) => {
  let childrenArr = null;

  const {
    props: { children },
  } = node;

  if (!children) {
    childrenArr = [];
  } else if (Array.isArray(children)) {
    childrenArr = children;
  } else {
    childrenArr = children.split(' ');
  }

  return childrenArr.reduce((acc, el) => {
    if (isObject(el)) {
      const res = getTextFromReactNode(el);
      return [...acc, ...res];
    }
    return [...acc, ...el.split(' ')];
  }, []);
};

export const formatNumber = num => (num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0);

export const formatBehaviorData = data =>
  data.reduce(
    (result, item) => [
      ...result,
      {
        buckets: item.buckets.map(bucket => ({
          value: bucket.count,
          date: new Date(bucket.name),
          associatedPattern: item.pattern_id,
          predicted: item.source === 'forecasted',
        })),
        associatedPattern: item.pattern_id,
      },
    ],
    [],
  );

export const getSeasonFromSelectedSeason = months => {
  if (_.isEqual(months, [1, 2, 3])) return seasons[0];
  if (_.isEqual(months, [4, 5, 6])) return seasons[1];
  if (_.isEqual(months, [7, 8, 9])) return seasons[2];
  if (_.isEqual(months, [10, 11, 12])) return seasons[3];

  throw new Error('could not find season');
};
